module.exports = __webpack_public_path__ + "11e510a8f31e2b85e3ad1de44868a472.fbx";